import cn from 'classnames';

import RichText from 'components/rich-text/RichText';
import Link from 'components/link/Link';

import { IRss } from 'source/NFR.types';

const Rss: React.FC<IRss> = ({ headerText, buttonText, info, url }) => (
  <>
    <div className={cn('rss-block')}>
      <div className={cn('rss-block__header')}>
        <h2>{headerText}</h2>
      </div>
      <div className={cn('rss-block__info')}>{info && <RichText {...info} />}</div>
      {url && (
        <Link theme={['primary', 'large']} useButtonStyles url={url}>
          {buttonText}
        </Link>
      )}
    </div>
  </>
);

Rss.displayName = 'Rss';

export default Rss;
